import React from 'react';
import { Row, Col } from 'react-bootstrap';
import WebhookCard from './WebhookCard';

export default function WebhookList({ webhooks, onDelete, isDeleting }) {
  if (!webhooks || webhooks.length === 0) {
    return null;
  }

  return (
    <>
      <h5 className="mb-3">Active Guesty Integrations</h5>
      <Row xs={1} md={2} className="g-4 mb-4">
        {webhooks.map((webhook, index) => (
          <Col key={webhook.webhook_id || index}>
            <WebhookCard 
              webhook={webhook} 
              index={index} 
              onDelete={onDelete} 
              isDeleting={isDeleting} 
            />
          </Col>
        ))}
      </Row>
    </>
  );
}
